import { createGlobalStyle } from "styled-components";

import { getFormElementColor, getMainColor, getStructureColor, getTextColor } from "./helpers";

export const GlobalStyle = createGlobalStyle`
	html, body {
		max-width: 100%;
		overflow-x: hidden;
		font-family: Poppins, sans-serif;
	}
	html *, body * {
		font-family: Poppins, sans-serif !important;
		/* Scrollbar style for Firefox */
		scrollbar-color: ${getFormElementColor("formElementBorder")} ${getMainColor("white")};
	}

	html {
		text-rendering: optimizeLegibility;
		-webkit-font-smoothing: antialiased;
		font-size: 62.5%; /* equal to 10px */
		margin: 0;
		padding: 0;
	}

	body {
		background-color: ${getMainColor("white")};
		color: ${getTextColor("bodyAndIcons")};
		font-size: 1.6rem;
		box-sizing: border-box;
	}

	/* Scrollbar styles for Chrome and Safari */
	::-webkit-scrollbar {
	  width: 1rem;
	  height: 1rem;
	}

	::-webkit-scrollbar-track {
	  box-shadow: inset 0 0 0.5rem grey;
	  border-radius: 0.5rem;
	  background-color: ${getMainColor("white")};
	}

	::-webkit-scrollbar-corner {
		background: ${getMainColor("white")};
	}

	::-webkit-scrollbar-thumb {
	  background: ${getFormElementColor("formElementBorder")};
	  border-radius: 0.5rem;
	}

	::-webkit-scrollbar-thumb:hover {
	  background: ${getStructureColor("hoverBG")};
	}

	a {
		color: inherit; /* blue colors for links too */
		text-decoration: inherit; /* no underline */
	}
`;
